import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getConsentDocuments, getConsentLinksDocuments } from './consentAsync';
import IConsentDocument from "models/Consent";
import Reducers from "types/Reducers";

interface IState {
  documents: IConsentDocument[] | null;
  linksDocuments: IConsentDocument[] | null;
};

const initialState:IState = {
  documents: null,
  linksDocuments: null,
};

const slice = createSlice({
  name: Reducers.Consent,
  initialState,
  reducers: {},
  extraReducers(builder) {
    // Get consent documents
    builder.addCase(getConsentDocuments.pending, (state) => {
      state.documents = null;
    });
    builder.addCase(getConsentDocuments.fulfilled, (state, action:PayloadAction<IConsentDocument[]>) => {
      state.documents = action.payload;
    });

    // Get consent links documents
    builder.addCase(getConsentLinksDocuments.pending, (state) => {
      state.linksDocuments = null;
    });
    builder.addCase(getConsentLinksDocuments.fulfilled, (state, action:PayloadAction<IConsentDocument[]>) => {
      state.linksDocuments = action.payload;
    });
  },
});

// export const { } = slice.actions;

export default slice.reducer;
